import useGetApi from 'src/api/useGetApi';

export interface SupplierByIdsDTO {
  id: string;
  name: string;
}

const buildQuery = (ids: string[]) => {
  const unique = Array.from(new Set(ids.filter(Boolean)));
  if (unique.length === 0) return '';
  // Keep commas unencoded so the server can split on ","
  // UUIDs are URL-safe, no need to encode
  return `?ids=${unique.join(',')}`;
};

export default function useSuppliersByIds(ids: string[], enabled = true) {
  const query = buildQuery(ids);
  return useGetApi<SupplierByIdsDTO[]>({
    endpoint: `accounts-payable/suppliers/by-ids${query}`,
    options: { enabled: enabled && ids.length > 0 },
  });
}
